import { useMemo } from 'react';
import { pick } from 'js/utils/ramda.util';

import * as hooks from './hooks';
import { useExportControl } from '../useExportControl';
import { useDynamicReducerSelector } from '../../store';

export const useTableHeader = () => {
    const filters = hooks.useFilters();
    const headerValidate = hooks.useValidate();
    const afterFiltersControls = useExportControl();
    const { anotherPeriodFilter, onAnotherPeriodApply } = hooks.useAnotherPeriod();
    const {
        filters: { period, status, type }, startDate, endDate
    } = useDynamicReducerSelector(pick(['filters', 'startDate', 'endDate']));

    const headerInitialValues = useMemo(() => ({
        type,
        period,
        status,
        from: startDate,
        until: endDate
    }), [period, status, type, startDate, endDate]);

    return useMemo(() => ({
        filters,
        headerValidate,
        headerInitialValues,
        anotherPeriodFilter,
        onAnotherPeriodApply,
        afterFiltersControls
    }), [
        filters, headerValidate, headerInitialValues,
        anotherPeriodFilter, onAnotherPeriodApply, afterFiltersControls
    ]);
};
